export enum NotificationType {
  Announcement = 'ANNOUNCEMENT',
  Portfolio = 'PORTFOLIO',
  Order = 'ORDER',
  Position = 'POSITION',
  Transfer = 'TRANSFER',
  Market = 'MARKET',
  News = 'NEWS',
  CorporateAction = 'CORPORATE_ACTION',
}
